/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Cat_Procedural_ErrorInputs */



/**
* | output |
* | --- |
* | "Procedural Error" |
*
* @param {Sanction_Cat_Procedural_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_cat_procedural_error = /** @type {((inputs?: Sanction_Cat_Procedural_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Cat_Procedural_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur de Procédure")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de Procedimiento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Erro de Procedimento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore Procedurale")
	return /** @type {LocalizedString} */ ("Procedural Error")
});